import React from "react";
import { useHistory } from "react-router-dom";
import {
	DashboardSectionContainer,
	DashboardTitle,
	DashboardContentContainer,
	DashboardDescription,
	CurrentModalContainer,
	CurrentModalText,
	/* ExpireDateText,
	ExpireDateValue, */
	ChargeManageButton,
	DashboardProgressBarContainer,
	ProgressBarMountContainer,
	SkillDescriptionContainer,
	SkillBarContainer,
	SkillValueBar,
	SkillValueText,
	ProgressBarMountTitle,
	DashboardLinkContainer,
	GuideLinkButton,
	FoodLensLinkContainer,
	GithubLinkContainer,
	GithubLinkTitle,
	GithubLinkContents,
	CaloAILinkContainer,
	SkillValuePointerCursor,
	SkillValuePointerDot,
	DescriptionUpperTitleImage,
	DashboardLabel,
	DashboardLabelWapper,
	DashboardListOpenSpan,
} from "./style";
// import { createTimeFormat } from "@/utils/timeFormat";
import { getDashboardInfo, getCurrentPlan } from "@/redux/organization/selector";
import Loader from "@/components/Loader";
import { useSelector } from "react-redux";
import { numberWithCommas } from "@/utils/number";
import ic_github from "@/assets/ic_github.svg";
import application_icon from "@/assets/application_icon.svg";
import { useTranslation } from "react-i18next";

const DashboardSection: React.FC = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const companyInfo = useSelector(getCurrentPlan);
	const dashboardInfo = useSelector(getDashboardInfo);
	const [isOpenDashboardList, setIsOpenDashboardList] = React.useState<boolean>(false);
	if (!companyInfo || !dashboardInfo) {
		return <Loader />;
	}
	return (
		<DashboardSectionContainer>
			<DashboardTitle>{t("home.dashboard")}</DashboardTitle>
			<DashboardContentContainer>
				<DashboardDescription>
					<div>
						{dashboardInfo.body.apps.length <= 2 ? (
							<>
								{dashboardInfo.body.apps.map((app, index) => {
									return (
										<CurrentModalContainer key={index}>
											<DescriptionUpperTitleImage>
												<img
													src={application_icon}
													alt="사진없음"
													style={{ width: "90%" }}
												/>
											</DescriptionUpperTitleImage>
											<CurrentModalText>
												{app.name}
											</CurrentModalText>
											<DashboardLabelWapper>
												<DashboardLabel>
													{app.isFoodLens
														? "FoodLens"
														: "CaloAI"}
												</DashboardLabel>
												<DashboardLabel>
													{app.planName === ""
														? t("pending_approval")
														: app.planName}
												</DashboardLabel>
											</DashboardLabelWapper>
										</CurrentModalContainer>
									);
								})}
							</>
						) : (
							<>
								{dashboardInfo.body.apps.map((app, index) => {
									return (
										<>
											{isOpenDashboardList ? (
												<CurrentModalContainer key={index}>
													<DescriptionUpperTitleImage>
														<img
															src={application_icon}
															alt="사진없음"
															style={{ width: "90%" }}
														/>
													</DescriptionUpperTitleImage>
													<CurrentModalText>
														{app.name}
													</CurrentModalText>
													<DashboardLabelWapper>
														<DashboardLabel>
															{app.isFoodLens
																? "FoodLens"
																: "CaloAI"}
														</DashboardLabel>
														<DashboardLabel>
															{app.planName === ""
																? t("pending_approval")
																: app.planName}
														</DashboardLabel>
													</DashboardLabelWapper>
												</CurrentModalContainer>
											) : (
												<>
													{index < 2 && (
														<CurrentModalContainer
															key={index}
														>
															<DescriptionUpperTitleImage>
																<img
																	src={application_icon}
																	alt="사진없음"
																	style={{
																		width: "90%",
																	}}
																/>
															</DescriptionUpperTitleImage>
															<CurrentModalText>
																{app.name}
															</CurrentModalText>
															<DashboardLabelWapper>
																<DashboardLabel>
																	{app.isFoodLens
																		? "FoodLens"
																		: "CaloAI"}
																</DashboardLabel>
																<DashboardLabel>
																	{app.planName === ""
																		? t(
																				"pending_approval",
																		  )
																		: app.planName}
																</DashboardLabel>
															</DashboardLabelWapper>
														</CurrentModalContainer>
													)}
												</>
											)}
										</>
									);
								})}
							</>
						)}
					</div>
					<ChargeManageButton
						variant="contained"
						onClick={() => {
							history.push(`/organization/general`);
						}}
					>
						{t("home.billing_management")}
					</ChargeManageButton>
				</DashboardDescription>
				{dashboardInfo.body.apps.length > 2 && (
					<div
						style={{
							textAlign: "center",
							marginBottom: "2rem",
						}}
					>
						<DashboardListOpenSpan
							onClick={() => setIsOpenDashboardList(!isOpenDashboardList)}
						>
							{isOpenDashboardList ? t("home.close") : t("home.more")}
						</DashboardListOpenSpan>
					</div>
				)}
				<div style={{ border: "1px solid #E0E0E0" }} />
				<DashboardProgressBarContainer>
					<ProgressBarMountContainer>
						<ProgressBarMountTitle>
							{t("home.total_usage_for_this_month")}
						</ProgressBarMountTitle>
						{/* <Link to="/organization/usage"> */}
						{/*	<span style={{ color: "#0071E3" }}>더 많은 사용량 보기</span> */}
						{/* </Link> */}
					</ProgressBarMountContainer>
					<SkillDescriptionContainer>
						<span>{t("home.call_count_for_foodlens")}</span>
						<span>
							{dashboardInfo.body.maxFoodLens === -1
								? "무제한"
								: `${t("total")} ${numberWithCommas(
										dashboardInfo.body.maxFoodLens,
								  )}`}
						</span>
					</SkillDescriptionContainer>
					<SkillBarContainer>
						{dashboardInfo.body.maxFoodLens === -1 ? (
							<>
								<SkillValueBar value="100%">
									<SkillValueText>
										{dashboardInfo.body.currentFoodLens
											.toString()
											.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
									</SkillValueText>
								</SkillValueBar>
								<SkillValuePointerCursor value="100%" />
								<SkillValuePointerDot value="99.85%" />
							</>
						) : (
							<>
								<SkillValueBar
									value={
										dashboardInfo.body.maxFoodLens !== 0
											? `${
													(dashboardInfo.body.currentFoodLens /
														dashboardInfo.body.maxFoodLens) *
													100
											  }%`
											: "0%"
									}
								>
									<SkillValueText>
										{dashboardInfo.body.currentFoodLens
											.toString()
											.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
									</SkillValueText>
								</SkillValueBar>
								<SkillValuePointerCursor
									value={`${
										dashboardInfo.body.maxFoodLens === 0
											? "0"
											: (dashboardInfo.body.currentFoodLens /
													dashboardInfo.body.maxFoodLens) *
											  100
									}%`}
								/>
								<SkillValuePointerDot
									value={`${
										dashboardInfo.body.maxFoodLens === 0
											? "-0.15"
											: (dashboardInfo.body.currentFoodLens /
													dashboardInfo.body.maxFoodLens) *
													100 -
											  0.15
									}%`}
								/>
							</>
						)}
					</SkillBarContainer>
					<SkillDescriptionContainer style={{ marginTop: "4.2rem" }}>
						<span>{t("home.call_count_for_caloai")}</span>
						<span>
							{dashboardInfo.body.maxCaloAI === -1
								? "무제한"
								: `${t("total")} ${numberWithCommas(
										dashboardInfo.body.maxCaloAI,
								  )}`}
						</span>
					</SkillDescriptionContainer>
					<SkillBarContainer>
						<SkillValueBar
							value={
								dashboardInfo.body.maxCaloAI === -1
									? "100%"
									: `${
											dashboardInfo.body.maxCaloAI === 0
												? "0"
												: (dashboardInfo.body.currentCaloAI /
														dashboardInfo.body.maxCaloAI) *
												  100
									  }%`
							}
						>
							<SkillValueText>
								{dashboardInfo.body.currentCaloAI}
							</SkillValueText>
						</SkillValueBar>
						<SkillValuePointerCursor
							value={
								dashboardInfo.body.maxCaloAI === -1
									? "100%"
									: `${
											dashboardInfo.body.maxCaloAI === 0
												? "0"
												: (dashboardInfo.body.currentCaloAI /
														dashboardInfo.body.maxCaloAI) *
												  100
									  }%`
							}
						/>
						<SkillValuePointerDot
							value={
								dashboardInfo.body.maxCaloAI === -1
									? "99.85%"
									: `${
											dashboardInfo.body.maxCaloAI === 0
												? "-0.15"
												: (dashboardInfo.body.currentCaloAI /
														dashboardInfo.body.maxCaloAI) *
														100 -
												  0.15
									  }%`
							}
						/>
					</SkillBarContainer>
				</DashboardProgressBarContainer>
			</DashboardContentContainer>
			<DashboardLinkContainer>
				<GithubLinkContainer>
					<FoodLensLinkContainer>
						<GithubLinkTitle>
							<img
								src={ic_github}
								alt="github icon"
								style={{ marginRight: "10px" }}
							/>
							<div style={{ alignSelf: "center" }}>
								{t("github_link_title_foodlens")}
							</div>
						</GithubLinkTitle>
						<GithubLinkContents>
							{t("github_link_contents_foodlens")}
						</GithubLinkContents>
						<GuideLinkButton
							variant="outlined"
							onClick={() => {
								window.open(
									"https://github.com/doinglab/FoodLensSDK/tree/master/Android",
								);
							}}
						>
							Android
						</GuideLinkButton>
						<GuideLinkButton
							variant="outlined"
							onClick={() => {
								window.open(
									"https://github.com/doinglab/FoodLensSDK/tree/master/IOS",
								);
							}}
						>
							iOS
						</GuideLinkButton>
					</FoodLensLinkContainer>
					<CaloAILinkContainer>
						<GithubLinkTitle>
							<img
								src={ic_github}
								alt="github icon"
								style={{ marginRight: "10px" }}
							/>
							<div style={{ alignSelf: "center" }}>
								{t("github_link_title_caloai")}
							</div>
						</GithubLinkTitle>
						<GithubLinkContents>
							{t("github_link_contents_caloai")}
						</GithubLinkContents>
						<GuideLinkButton
							variant="outlined"
							onClick={() => {
								window.open(
									"https://github.com/doinglab/CaloAISDK/tree/main/Android",
								);
							}}
						>
							Android
						</GuideLinkButton>
						<GuideLinkButton
							variant="outlined"
							onClick={() => {
								window.open(
									"https://github.com/doinglab/CaloAISDK/tree/main/IOS",
								);
							}}
						>
							iOS
						</GuideLinkButton>
					</CaloAILinkContainer>
				</GithubLinkContainer>
			</DashboardLinkContainer>
		</DashboardSectionContainer>
	);
};

export default DashboardSection;
